import React from 'react';
import PropTypes from 'prop-types';

import {Link} from 'react-router-dom';

import withNavigate from './withNavigate';

const CustomProgressBar = props => {
	const { onStepClick, pages } = props;
	return (
		<>
			<div className='stepwizard stepright-12 mb-5'>
				<div className='stepwizard-row'>
					{pages.map(page => {
						const hrefVal = page.href.replace('#', '/');
						return(
							<Link
								className={page.state}
								to={hrefVal}
								key={page.key}
								onClick={event => onStepClick?.(page, event)}
							>
								<span className='stepwizard-badge' />
								<span className='stepwizard-title'>{page.title}</span>
							</Link>
						)
					})}
				</div>
			</div>
		</>
	);
}

CustomProgressBar.propTypes = {
	onStepClick: PropTypes.func,
	pages: PropTypes.array
}

export default withNavigate(CustomProgressBar);